export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8380.82adcac7.jpg";